var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9939 13.8096C23.883 13.8082 23.773 13.8298 23.671 13.8732C20.4165 14.045 17.7697 16.6113 17.5949 19.8669C17.5892 19.9719 17.6043 20.0769 17.6392 20.176C17.6741 20.2751 17.7282 20.3664 17.7983 20.4446C17.8685 20.5228 17.9534 20.5864 18.0482 20.6318C18.1429 20.6772 18.2457 20.7035 18.3506 20.7092C18.4556 20.7148 18.5606 20.6998 18.6597 20.6649C18.7588 20.63 18.8501 20.5759 18.9283 20.5057C19.0065 20.4355 19.0701 20.3506 19.1155 20.2559C19.1609 20.1611 19.1872 20.0583 19.1928 19.9534C19.3288 17.422 21.4228 15.4096 23.9939 15.4096C26.6525 15.4096 28.8022 17.5579 28.8022 20.2138C28.8022 22.4331 27.8388 23.2294 26.547 24.3211C25.2552 25.4127 23.6112 26.744 23.2647 29.4034C23.2492 29.5084 23.2548 29.6155 23.2811 29.7184C23.3074 29.8212 23.354 29.9178 23.418 30.0025C23.482 30.0872 23.5622 30.1583 23.654 30.2117C23.7458 30.2651 23.8473 30.2997 23.9526 30.3134C24.0579 30.3272 24.1648 30.3198 24.2672 30.2918C24.3697 30.2638 24.4655 30.2157 24.5491 30.1503C24.6327 30.0849 24.7025 30.0035 24.7544 29.9109C24.8062 29.8182 24.8391 29.7162 24.8512 29.6107C25.127 27.4935 26.255 26.6621 27.5793 25.543C28.9036 24.4238 30.4022 22.9615 30.4022 20.2138C30.4022 16.806 27.6888 14.0581 24.323 13.8763C24.2193 13.831 24.1071 13.8083 23.9939 13.8096ZM24.0001 32.9763C23.5591 32.9763 23.2001 33.3342 23.2001 33.7753C23.2001 34.2163 23.5591 34.5753 24.0001 34.5753C24.4412 34.5753 24.8001 34.2174 24.8001 33.7763C24.8001 33.3352 24.4412 32.9763 24.0001 32.9763Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.f3db50f79f5e6a00f9626cd91cecde9e.svg";
export { ForwardRef as ReactComponent };